import styled from "styled-components";

const SectionLeadContainer = styled.div`
  padding-bottom: 120px;
`;

export { SectionLeadContainer };
